export default __webpack_public_path__ + "static/media/08.e7db3b80.jpg";